/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_EmailInputs */

const en_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const fr_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const es_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electronico`)
};

const it_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const nl_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const pl_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const fi_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköposti`)
};

const da_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const sv_resume_editor_email = /** @type {(inputs: Resume_Editor_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Resume_Editor_EmailInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_email = /** @type {((inputs?: Resume_Editor_EmailInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_EmailInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_email(inputs)
	if (locale === "fr") return fr_resume_editor_email(inputs)
	if (locale === "es") return es_resume_editor_email(inputs)
	if (locale === "it") return it_resume_editor_email(inputs)
	if (locale === "nl") return nl_resume_editor_email(inputs)
	if (locale === "pl") return pl_resume_editor_email(inputs)
	if (locale === "fi") return fi_resume_editor_email(inputs)
	if (locale === "da") return da_resume_editor_email(inputs)
	if (locale === "sv") return sv_resume_editor_email(inputs)
	return en_resume_editor_email(inputs)
});